import { get, getAll } from './Provider';
import { IProject } from './model/IProject';
import { ITask } from './model/ITask';

const RESOURCE = 'projects';

export const Project = {
  get: (id: string) => get<IProject>(RESOURCE, id),
  getTasks: async (id: string) => (await getAll<ITask>(`${RESOURCE}/${id}/tasks`)),
  getAll: () => getAll<IProject>(RESOURCE, '$orderby=Name asc')
}